module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-800.woff2?b5cd7d83a71851bd0d449c3cd5ddadfc";